import  React  from "react";
import { Outlet,Navigate } from "react-router-dom";
import { getCookie } from '../../redux/utils/helpers';

const PrivateRoutes = () => getCookie("refresh_token") ? <Outlet /> : <Navigate to="/sign-in" />
export default PrivateRoutes;